module.exports = __webpack_public_path__ + "static/home-video-906e38c467fd56599fc5d964256f90ae.ogv";